export default __webpack_public_path__ + "static/media/Bonus_History_Cashflow_Protection_Plus.2dc5643f.pdf";